import { Card } from "@/components/Kpi";
import { SelettoreAgenzie } from "@/components/corto/SelettoreAgenzie";
import { inputCls } from "@/components/Filters";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto",
  "Settembre", "Ottobre", "Novembre", "Dicembre"];
const CATEGORIE = [["non_garantito", "Non garantito"], ["garantito", "Garantito"],
  ["vivibanca", "Vivibanca"]];
const STATI = [["accettata", "Accettata"], ["attesa", "In attesa"], ["respinta", "Respinta"],
  ["ritirata", "Ritirata"], ["rinuncia", "Rinuncia"]];

export const FILTRI_CORTO_VUOTI = { mese: "", dal: "", al: "", agenzia: "", categoria: "",
  stato_pratica: "", escludi: "", risorsa: "" };

/** Barra filtri del canale corto: periodo, agenzia, risorsa, prodotto e stato.
 *  Con `agenziaFissa` (scheda agenzia) spariscono agenzia ed esclusioni e le risorse sono le sue. */
export const FiltriCorto = ({ valori, onChange, agenzie, risorse = [], agenziaFissa }) => {
  const set = (k, v) => onChange({ ...valori, [k]: v || "" });
  const escluse = (valori.escludi || "").split(",").filter(Boolean);
  const attivi = Object.values(valori).some(Boolean);
  const agenziaScelta = agenziaFissa || valori.agenzia;
  const risorseVisibili = agenziaScelta
    ? risorse.filter((r) => r.agenzie.some((a) => a.agenzia === agenziaScelta))
    : risorse;
  const cambiaAgenzia = (v) => {
    const ok = !valori.risorsa || !v || valori.risorsa === "OPERATRICI LUNGO"
      || risorse.some((r) => r.nome === valori.risorsa && r.agenzie.some((a) => a.agenzia === v));
    onChange({ ...valori, agenzia: v || "", risorsa: ok ? valori.risorsa : "" });
  };
  return (
    <Card className="p-4" data-testid="corto-filtri">
      <div className="flex flex-wrap items-end gap-3">
        <div className="w-40">
          <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Mese</label>
          <select className={inputCls} value={valori.mese} data-testid="filtro-corto-mese"
            onChange={(e) => set("mese", e.target.value)}>
            <option value="">Tutti</option>
            {MESI.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
          </select>
        </div>
        <div className="w-36">
          <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Dal</label>
          <input type="date" className={inputCls} value={valori.dal} data-testid="filtro-corto-dal"
            onChange={(e) => set("dal", e.target.value)} />
        </div>
        <div className="w-36">
          <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Al</label>
          <input type="date" className={inputCls} value={valori.al} data-testid="filtro-corto-al"
            onChange={(e) => set("al", e.target.value)} />
        </div>
        {!agenziaFissa ? (
          <div className="w-48">
            <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Agenzia</label>
            <select className={inputCls} value={valori.agenzia} data-testid="filtro-corto-agenzia"
              onChange={(e) => cambiaAgenzia(e.target.value)}>
              <option value="">Tutte</option>
              {agenzie.map((a) => <option key={a.slug} value={a.agenzia}>{a.agenzia}</option>)}
            </select>
          </div>
        ) : null}
        <div className="w-56">
          <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Risorsa</label>
          <select className={inputCls} value={valori.risorsa || ""} data-testid="filtro-corto-risorsa"
            onChange={(e) => set("risorsa", e.target.value)}>
            <option value="">Tutte</option>
            <option value="OPERATRICI LUNGO">Operatrici del lungo (tutte)</option>
            {risorseVisibili.map((r) => (
              <option key={r.nome} value={r.nome}>
                {r.nome}{!agenziaScelta && r.agenzie.length > 1 ? ` (${r.agenzie.length} agenzie)` : ""}
              </option>
            ))}
          </select>
        </div>
        <div className="w-44">
          <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Prodotto</label>
          <select className={inputCls} value={valori.categoria} data-testid="filtro-corto-prodotto"
            onChange={(e) => set("categoria", e.target.value)}>
            <option value="">Tutti</option>
            {CATEGORIE.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        <div className="w-40">
          <label className="text-[11px] uppercase tracking-wider text-slate-400 block mb-1">Stato</label>
          <select className={inputCls} value={valori.stato_pratica} data-testid="filtro-corto-stato"
            onChange={(e) => set("stato_pratica", e.target.value)}>
            <option value="">Tutti</option>
            {STATI.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        {!agenziaFissa ? (
          <div className="w-full sm:w-56">
            <SelettoreAgenzie agenzie={agenzie} escluse={escluse} etichetta="Agenzie incluse"
              testId="filtro-corto-escludi"
              onChange={(lista) => set("escludi", lista.join(","))} />
          </div>
        ) : null}
        {attivi ? (
          <button data-testid="filtro-corto-azzera"
            onClick={() => onChange({ ...FILTRI_CORTO_VUOTI })}
            className="rounded-md px-4 py-2 text-sm border border-slate-200 text-slate-600
              hover:border-slate-900 hover:text-slate-900 transition-colors duration-200">
            Azzera filtri
          </button>
        ) : null}
      </div>
      {attivi ? (
        <div className="mt-3 text-xs text-slate-500">
          I filtri agiscono su box KPI, grafici mensili, confronto anno precedente, progressivo YTD e
          classifiche; i tachimetri restano sui totali dell'anno.
          {valori.risorsa ? ` Risorsa: ${valori.risorsa}.` : ""}
          {escluse.length ? ` Agenzie escluse: ${escluse.join(", ")}.` : ""}
        </div>
      ) : null}
    </Card>
  );
};
